import { all, fork } from 'redux-saga/effects'
import { billingSaga } from '@/features/billing/store/sagas'

export default function* rootSaga() {
  yield all([fork(billingSaga)])
}
